import CNBDatePicker from "components/CNBDatePicker";
import ICustomer from "models/ICustomer";
import IUser from "models/IUser";
import React from "react";
import Input from "components/Input";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import _ from "lodash";
import BackgroundBlock from "../deliveryNotes/partials/BackgroundBlock";
import CNBTextArea from "components/CNBTextArea";
import Checkbox from "components/Checkbox";
import NumberInput from "components/NumberInput";
import "./style.scss";
import Button from "components/Button";
import { localRequest } from "../../apiUtils";
import Swal from "helpers/swal";

interface IProps {
  currentCustomer: ICustomer;
  user: IUser;
  onBackClick: () => void;
  sendContactForm: (params) => void;
  intl: any;
  userName: string;
  changeField: (fieldname: string, value: any) => void;
}

interface IState {
  [key: string]: any;
  error: any;
  touched: any;
  userAgreementToTermsAndConditions: boolean;

  // Form data
  name: string;
  address: string;
  date: Date;
  place: string;
  agreementNumber: string;
  transactionDetails: Array<{
    orderNumber: string;
    quantityReceived: string;
    numberOfBulbs: number;
    species: string;
    mate: string;
    price: number;
  }>;

  // [flower Condition]
  bulbsAvailable: boolean;
  noOfSpheres: boolean;
  areOrbsDestroyed: boolean;
  other: boolean;
  otherFlowerCondition?: string;

  // [Buyer info]
  relationshipNumber: string;
  buyerName: string;
  buyerAddress: string;
  buyerPlace: string;
}

interface IError {
  title: string;
  description: string;
}

class CustomerComplaints extends React.Component<IProps, IState> {
  private baseState: any;

  constructor(props) {
    super(props);
    this.state = {
      email: "",
      error: null,
      touched: {},
      userAgreementToTermsAndConditions: false,
      name: "",
      address: "",
      agreementNumber: "",
      place: "",
      transactionDetails: [
        {
          orderNumber: "",
          quantityReceived: "",
          numberOfBulbs: 0,
          species: "",
          mate: "",
          price: 0,
        },
      ],
      date: new Date(),
      flowerCondition: [],
      relationshipNumber: "",
      buyerName: "",
      buyerAddress: "",
      buyerPlace: "",

      // [flower Condition]
      bulbsAvailable: false,
      noOfSpheres: false,
      areOrbsDestroyed: false,
      other: false,
      otherFlowerCondition: "",
    };
    this.baseState = this.state;
  }

  private handleTransactionDetail = (e: any, index: number) => {
    const updatedValues = this.state.transactionDetails.map(
      (transaction, i: number) =>
        index === i
          ? Object.assign(transaction, { [e.target.name]: e.target.value })
          : transaction
    );
    this.setState({ ...this.state, transactionDetails: [...updatedValues] });
  };

  private validateFieldByRegex(
    regEx: RegExp,
    e: any,
    errorMessage: IError
  ): void {
    const value = e.target.value;
    setTimeout(() => {
      if (value && !regEx.test(value)) {
        const {
          intl: { formatMessage },
        } = this.props;
        Swal.alert(
          formatMessage({ id: errorMessage.title }),
          formatMessage({ id: errorMessage.description }),
          "error"
        );
      }
    }, 2000);
  }

  private handleFieldChange(name, value) {
    this.setState({ [name]: value });
  }
  private isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  private handleSubmit = async (e) => {
    e.preventDefault();
    const {
      name,
      address,
      date,
      place,
      agreementNumber,
      // buyer details
      buyerAddress,
      buyerName,
      buyerPlace,
      relationshipNumber,
      email,
      transactionDetails,
    } = this.state;
    const requestPayload = {
      name,
      email: this.props.userName,
      sellerEmail: email,
      address,
      date,
      place,
      agreementNumber,
      buyerAddress,
      buyerName,
      buyerPlace,
      relationshipNumber,
      transactionDetails,
      flowerCondition: this.formatFlowerCondition(),
    };
    if (!email) {
      Swal.alert(
        "warning",
        "Vul hier het e-mail adres van de verkoper in, zo wordt de verkoper direct op de hoogte gebracht van de zuurnota."
      );
      return;
    }
    if (!this.isValidEmail(email)) {
      Swal.alert("warning", "Vul een geldig e-mail adres in.");
      return;
    }
    try {
      const { status } = await localRequest.post(
        "email/send-complaint-email",
        requestPayload
      );
      if (status === 200) {
        this.resetForm();
      }
    } catch (error) {
      console.log(error);
    }
  };

  private resetForm = () => {
    this.setState({
      ...this.baseState,
      transactionDetails: [
        {
          orderNumber: "",
          quantityReceived: "",
          numberOfBulbs: 0,
          species: "",
          mate: "",
          price: 0,
        },
      ],
    });
  };

  private formatFlowerCondition = () => {
    const returnValue: string[] = [];
    if (this.state.bulbsAvailable) {
      returnValue.push("De bollen staan ter beschikking");
    }
    if (this.state.noOfSpheres) {
      returnValue.push(
        "Het aantal zure bollen is bepaald door monstertrekking"
      );
    }
    if (this.state.areOrbsDestroyed) {
      returnValue.push(
        "De bollen zijn/worden vernietigd (Let op: Termijn bewaarplicht koper volgens Artikel 8.9 lid 1 HR)"
      );
    }
    if (
      this.state.other &&
      this.state.otherFlowerCondition &&
      this.state.otherFlowerCondition !== ""
    ) {
      returnValue.push(this.state.otherFlowerCondition);
    }
    return returnValue;
  };

  private handleAddFlowerCondition = (e) => {
    e.preventDefault();
    const emptyState = {
      orderNumber: "",
      quantityReceived: "",
      numberOfBulbs: 0,
      species: "",
      mate: "",
      price: 0,
    };
    this.setState({
      transactionDetails: this.state.transactionDetails.concat([emptyState]),
    });
  };

  private handleDeleteRow = (e, index: number) => {
    e.preventDefault();
    const updatedList = [...this.state.transactionDetails];
    updatedList.splice(index, 1);
    this.setState({
      transactionDetails: updatedList,
    });
  };

  public render() {
    const {
      address,
      name,
      place,
      agreementNumber,
      relationshipNumber,
      buyerName,
      buyerAddress,
      buyerPlace,
      transactionDetails,
      bulbsAvailable,
      noOfSpheres,
      areOrbsDestroyed,
      other,
      otherFlowerCondition,
      userAgreementToTermsAndConditions,
      email,
    } = this.state;

    return (
      <div className="orders-page">
        <FormattedMessage id="CUSTOMER_COMPLAINTS" tagName="h1" />
        <form id="new-cultivation-advice" onSubmit={this.handleSubmit}>
          <BackgroundBlock className="advice-form">
            <Input
              onChange={(e) => this.handleFieldChange("name", e.target.value)}
              name="NAME"
              label="SELLER_NAME"
              placeholder="SELLER_NAME"
              required
              value={name}
            />
            <CNBTextArea
              onChange={(e) =>
                this.handleFieldChange("address", e.target.value)
              }
              name="ADDRESS"
              label="ADDRESS"
              rows={1}
              value={address}
            />
            <CNBTextArea
              onChange={(e) => this.handleFieldChange("place", e.target.value)}
              name="PLACE"
              label="PLACE"
              rows={1}
              value={place}
            />
            <CNBTextArea
              onChange={(e) => this.handleFieldChange("email", e.target.value)}
              name="email"
              label="SELLER_EMAIL"
              rows={1}
              value={email}
              requiredIcon
            />
            <div className="datum">
              <FormattedMessage id="DATE" tagName="label" />
              <CNBDatePicker
                startDate={new Date()}
                onChange={(value) => this.handleFieldChange("date", value)}
              />
            </div>

            <>
              <div className="mt-20 pt-20 border-top">
                <FormattedMessage
                  id="THE_UNDESIGNED_DECLARES_THE_NUMBER_OF_SOUR_BULBS"
                  tagName="h4"
                />
              </div>
              <div className="tableWrap mt-30 pb-20 border-bottom">
                <table className="tableWrap">
                  <thead>
                    <tr>
                      <th className="capitalizeText">
                        <FormattedMessage id="AGREEMENT_NUMBER" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="QUANTITY_RECEIVED" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="NUMBER_OF_BULBS" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="SPECIES_CULTIVAR" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="MATE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="PRICE" />
                      </th>
                      <th className="capitalizeText"> &nbsp; </th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactionDetails.map((transactionDetail, index) => (
                      <tr>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.handleTransactionDetail(e, index)
                            }
                            name="orderNumber"
                            placeholder="AGREEMENT_NUMBER"
                            required
                            class="half-width-50 "
                            value={transactionDetail.orderNumber}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.handleTransactionDetail(e, index)
                            }
                            name="quantityReceived"
                            placeholder="QUANTITY_RECEIVED"
                            required
                            class="half-width-50 "
                            value={transactionDetail.quantityReceived}
                          />
                        </td>
                        <td>
                          <NumberInput
                            onChange={(e) =>
                              this.handleTransactionDetail(e, index)
                            }
                            name="numberOfBulbs"
                            placeholder="NUMBER_OF_BULBS"
                            required
                            class="half-width-50 "
                            value={transactionDetail.numberOfBulbs}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.handleTransactionDetail(e, index)
                            }
                            name="species"
                            placeholder="SPECIES_CULTIVAR"
                            required
                            class="half-width-50 "
                            value={transactionDetail.species}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.handleTransactionDetail(e, index)
                            }
                            name="mate"
                            placeholder="MATE"
                            required
                            class="half-width-50 "
                            value={transactionDetail.mate}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) => {
                              this.handleTransactionDetail(e, index);
                            }}
                            name="price"
                            placeholder="PRICE"
                            class="half-width-50 "
                            value={transactionDetail.price}
                          />
                        </td>
                        <td className="half-width-50">
                          <Button
                            onClick={(e) => this.handleDeleteRow(e, index)}
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="button-container border-bottom">
                <Button
                  onClick={this.handleAddFlowerCondition}
                  kind="primary"
                  type="button"
                  className="p-10"
                >
                  PLUS_SIGN
                </Button>
              </div>
            </>

            <>
              <div className="mt-20 pt-20">
                <FormattedMessage
                  id="CHECK_AND_COMPLETE_BELOW_AS"
                  tagName="h4"
                />
              </div>

              <div className="checkbox-row">
                <Checkbox
                  borderColor="#CDD2D6"
                  checked={bulbsAvailable}
                  labelText={"BULBS_ARE_AVAILABLE"}
                  onChange={(checked) =>
                    this.handleFieldChange("bulbsAvailable", checked)
                  }
                />
              </div>
              <div className="checkbox-row">
                <Checkbox
                  borderColor="#CDD2D6"
                  checked={noOfSpheres}
                  labelText={"NO_OF_SPHERES"}
                  onChange={(checked) =>
                    this.handleFieldChange("noOfSpheres", checked)
                  }
                />
              </div>
              <div className="checkbox-row">
                <Checkbox
                  borderColor="#CDD2D6"
                  checked={areOrbsDestroyed}
                  labelText={"ORBS_ARE_DESTROYED"}
                  onChange={(checked) =>
                    this.handleFieldChange("areOrbsDestroyed", checked)
                  }
                />
              </div>
              <div className="checkbox-row">
                <Checkbox
                  borderColor="#CDD2D6"
                  checked={other}
                  labelText={"OTHER_VIZ"}
                  onChange={(checked) =>
                    this.handleFieldChange("other", checked)
                  }
                />
                {other && (
                  <Input
                    onChange={(e) =>
                      this.handleFieldChange(
                        "otherFlowerCondition",
                        e.target.value
                      )
                    }
                    name="otherFlowerCondition"
                    placeholder="OTHER_VIZ"
                    required
                    value={otherFlowerCondition}
                  />
                )}
              </div>
            </>

            <>
              <div className="mt-20 pt-20 border-top">
                <FormattedMessage
                  id="COMPLETE_BUYER_INFORMATION"
                  tagName="h4"
                />
              </div>
              <Input
                onChange={(e) =>
                  this.handleFieldChange("relationshipNumber", e.target.value)
                }
                name="RELATIONSHIP_NO"
                label="RELATIONSHIP_NO"
                placeholder="RELATIONSHIP_NO"
                required
                value={relationshipNumber}
              />
              <Input
                onChange={(e) =>
                  this.handleFieldChange("buyerName", e.target.value)
                }
                name="BUYER_NAME"
                label="BUYER_NAME"
                placeholder="BUYER_NAME"
                required
                value={buyerName}
              />
              <CNBTextArea
                onChange={(e) =>
                  this.handleFieldChange("buyerAddress", e.target.value)
                }
                name="ADDRESS"
                label="ADDRESS"
                rows={1}
                value={buyerAddress}
              />
              <CNBTextArea
                onChange={(e) =>
                  this.handleFieldChange("buyerPlace", e.target.value)
                }
                name="PLACE"
                label="PLACE"
                rows={1}
                value={buyerPlace}
              />
              <div className="checkbox-row">
                <Checkbox
                  borderColor="#CDD2D6"
                  checked={userAgreementToTermsAndConditions}
                  labelText={"COMPLAINT_AGREEMENT_LABEL"}
                  onChange={(checked) =>
                    this.handleFieldChange(
                      "userAgreementToTermsAndConditions",
                      checked
                    )
                  }
                />
              </div>
              <div className="button-container">
                <Button
                  type="submit"
                  kind="primary"
                  disabled={!userAgreementToTermsAndConditions}
                >
                  SUBMIT
                </Button>
              </div>
            </>
          </BackgroundBlock>
        </form>
      </div>
    );
  }
}

export default connect((state) => ({
  userName: state.app.userName,
}))(injectIntl(CustomerComplaints));
